export interface Woman {
  puzzlenumber: number;
  lastname: string;
  quote: string;
  link: string;
  bio: string;
  image: string;
  attribution: string | null;
}

// Bio sourced and modified from Wikipedia
// Quotes sourced from:
// https://en.wikiquote.org/
//  https://www.inspiringquotes.us/
//  https://quotationsbywomen.com/

// Images sourced from Wikipedia

//public domain
export const Women: Woman[] = [
  {
    puzzlenumber: 1,
    lastname: "Johnson",
    quote:
      "There will always, always be mathematics. Everything is physics and math.",
    link: "https://en.wikipedia.org/wiki/Katherine_Johnson",
    bio: "Creola Katherine Johnson was an American human computer whose calculations of orbital mechanics as a NASA employee were critical to the success of the first and subsequent U.S. crewed spaceflights.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6d/Katherine_Johnson_1983.jpg/500px-Katherine_Johnson_1983.jpg",
    attribution: "public domain image",
  },
  //public domain image
  {
    puzzlenumber: 2,
    lastname: "Ginsburg",
    quote:
      "My mother told me to be a lady. And for her, that meant be your own person, be independent.",
    link: "https://en.wikipedia.org/wiki/Ruth_Bader_Ginsburg",
    bio: "Joan Ruth Bader Ginsburg was an American lawyer and jurist who served as an associate justice of the Supreme Court of the United States. Ginsburg spent much of her legal career as an advocate for gender equality and women's rights, winning many arguments before the Supreme Court.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/76/Ruth_Bader_Ginsburg_2016_portrait.jpg/960px-Ruth_Bader_Ginsburg_2016_portrait.jpg",
    attribution: "public domain image",
  },
  //no restrictions image
  {
    puzzlenumber: 3,
    lastname: "Wu",
    quote:
      "There is a misconception in America that women scientists are all dowdy spinsters.",
    link: "https://en.wikipedia.org/wiki/Chien-Shiung_Wu",
    bio: "Chien-Shiung Wu was a Chinese-American particle and experimental physicist. Wu worked on the Manhattan Project, where she helped develop the process for separating uranium into uranium-235 and uranium-238 isotopes by gaseous diffusion.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d2/Chien-shiung_Wu_%281912-1997%29_C.jpg/960px-Chien-shiung_Wu_%281912-1997%29_C.jpg",
    attribution: "no copyright restrictions image",
  },
  //public domain
  {
    puzzlenumber: 4,
    lastname: "Angelou",
    quote:
      "Prepare yourself so that you can be a rainbow in somebody else's cloud.",
    link: "https://en.wikipedia.org/wiki/Maya_Angelou",
    bio: "Maya Angelou was an American memoirist, poet, and civil rights activist. She received dozens of awards and more than 50 honorary degrees. She made a deliberate attempt to challenge the common structure of the autobiography by critiquing, changing and expanding the genre.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Angelou_at_Clinton_inauguration_%28cropped_2%29.jpg/960px-Angelou_at_Clinton_inauguration_%28cropped_2%29.jpg",
    attribution: "public domain image",
  },
  //public domain
  {
    puzzlenumber: 5,
    lastname: "Earhart",
    quote:
      "Women must try to do things as men have tried. When they fail, their failure must be but a challenge to others.",
    link: "https://en.wikipedia.org/wiki/Amelia_Earhart",
    bio: "Amelia Mary Earhart was an American aviation pioneer and writer. Earhart was the first female aviator to fly solo across the Atlantic Ocean. She was instrumental in the formation of The Ninety-Nines, an organization for female pilots.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/7/72/Amelia_Earhart_standing_under_nose_of_her_Lockheed_Model_10-E_Electra%2C_small_%28cropped%29.jpg",
    attribution: "public domain image",
  },
  //public domain
  {
    puzzlenumber: 6,
    lastname: "Chawla",
    quote:
      "The path from dreams to success does exist. May you have the vision to find it, the courage to get on it and the perseverance to follow it.",
    link: "https://en.wikipedia.org/wiki/Kalpana_Chawla",
    bio: "Kalpana Chawla was an Indian-born American astronaut and aerospace engineer who was the first woman of Indian origin to fly to space. She first flew on Space Shuttle Columbia in 1997 as a mission specialist and primary robotic arm operator aboard STS-87.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Kalpana_Chawla%2C_NASA_photo_portrait_in_orange_suit.jpg/960px-Kalpana_Chawla%2C_NASA_photo_portrait_in_orange_suit.jpg",
    attribution: "public domain image",
  },
  //public domain
  {
    puzzlenumber: 7,
    lastname: "Hopper",
    quote: "I've always been more interested in the future than in the past.",
    link: "https://en.wikipedia.org/wiki/Grace_Hopper",
    bio: "Grace Brewster Hopper was an American computer scientist, mathematician, and United States Navy rear admiral. One of the first programmers of the Harvard Mark I computer, she was a pioneer of computer programming.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/98/Commodore_Grace_M._Hopper%2C_USN_%28covered%29_head_and_shoulders_crop.jpg/960px-Commodore_Grace_M._Hopper%2C_USN_%28covered%29_head_and_shoulders_crop.jpg",
    attribution: "public domain image",
  },
  //public domain
  {
    puzzlenumber: 8,
    lastname: "Lovelace",
    quote:
      "That brain of mine is something more than merely mortal; as time will show.",
    link: "https://en.wikipedia.org/wiki/Ada_Lovelace",
    bio: "Augusta Ada King, Countess of Lovelace was an English mathematician and writer, chiefly known for her work on the Analytical Engine. She was the first to recognise that the machine had applications beyond pure calculation.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/4/4c/Ada_Lovelace_daguerreotype_by_Antoine_Claudet_1843_-_cropped.png",
    attribution: "public domain image",
  },
  //public domain
  {
    puzzlenumber: 9,
    lastname: "Curie",
    quote: "I was taught that the way of progress was neither swift nor easy.",
    link: "https://en.wikipedia.org/wiki/Marie_Curie",
    bio: "Maria Salomea Skłodowska-Curie, known simply as Marie Curie, was a Polish and naturalised-French physicist and chemist who conducted pioneering research on radioactivity. Marie won the 1911 Nobel Prize in Chemistry for her discovery of the elements polonium and radium, using techniques she invented for isolating radioactive isotopes.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/Marie_Curie_c._1920s.jpg/960px-Marie_Curie_c._1920s.jpg",
    attribution: "public domain image",
  },
  //public domain
  {
    puzzlenumber: 10,
    lastname: "Tubman",
    quote:
      "When I found I had crossed that line, I looked at my hands to see if I was the same person.",
    link: "https://en.wikipedia.org/wiki/Harriet_Tubman",
    bio: "Harriet Tubman was an American abolitionist and social activist. After escaping slavery, Tubman made some 13 missions to rescue approximately 70 enslaved people, including her family and friends, using the network of antislavery activists and safe houses known collectively as the Underground Railroad.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/Carte-de-visite_portrait_of_Harriet_Tubman_%28cropped%29.jpg/960px-Carte-de-visite_portrait_of_Harriet_Tubman_%28cropped%29.jpg",
    attribution: "public domain image",
  },
  //public domain
  {
    puzzlenumber: 11,
    lastname: "O'Connor",
    quote: "We don't accomplish anything in this world alone.",
    link: "https://en.wikipedia.org/wiki/Sandra_Day_O%27Connor",
    bio: "Sandra Day O'Connor was an American attorney, politician, and jurist who served as an associate justice of the Supreme Court of the United States. She often wrote concurring opinions that sought to limit the reach of the majority holding.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/00/Sandra_Day_O%27Connor.jpg/960px-Sandra_Day_O%27Connor.jpg",
    attribution: "public domain image",
  },

  //creative commons
  {
    puzzlenumber: 12,
    lastname: "Tabei",
    quote:
      "Technique and ability alone do not get you to the top; it is the willpower that is the most important.",
    link: "https://en.wikipedia.org/wiki/Junko_Tabei",
    bio: "Junko Tabei was a Japanese mountaineer, author, and teacher. She was the first woman to reach the summit of Mount Everest and first woman to ascend the Seven Summits, climbing the highest peak on every continent.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/5/57/Junko_Tabei_85_%283to4%29.jpg",
    attribution:
      "By Jaan Künnap - Own work, CC BY-SA 4.0, https://commons.wikimedia.org/w/index.php?curid=117727520",
  },
  //public domain
  {
    puzzlenumber: 13,
    lastname: "Cruz",
    quote: "My message is always felicidad - happiness.",
    link: "https://en.wikipedia.org/wiki/Celia_Cruz",
    bio: "Celia Caridad Cruz Alfonso, known as Celia Cruz, was a Cuban singer and one of the most popular Latin artists of the 20th century. She had sold over 10 million records, making her one of the best-selling Latin music artists.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/8/89/Celia_Cruz_1957_color.jpg",
    attribution: "public domain image",
  },
  //creative commons
  {
    puzzlenumber: 14,
    lastname: "Maathai",
    quote:
      "The generation that destroys the environment is not the generation that pays the price. That is the problem.",
    link: "https://en.wikipedia.org/wiki/Wangari_Maathai",
    bio: "Wangarĩ Muta Maathai was a Kenyan social, environmental, and political activist who founded the Green Belt Movement, an environmental non-governmental organization focused on the planting of trees, environmental conservation, and women's rights.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/d/da/Wangari_Maathai_in_2001.jpg",
    attribution:
      "By Kingkongphoto & www.celebrity-photos.com from Laurel Maryland, USA - Wangari Maathai 2004 Nobel Peace prize winner, CC BY-SA 2.0, https://commons.wikimedia.org/w/index.php?curid=75053665",
  },
  //public domain
  {
    puzzlenumber: 15,
    lastname: "Ride",
    quote:
      "If we want scientists and engineers in the future, we should be cultivating the girls as much as the boys.",
    link: "https://en.wikipedia.org/wiki/Sally_Ride",
    bio: "Sally Kristen Ride was an American astronaut and physicist. In 1983 she became the first American woman and the third woman to fly in space, and she is the first astronaut known to have been LGBTQ.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0c/Sally_Ride_%281984%29.jpg/960px-Sally_Ride_%281984%29.jpg",
    attribution: "public domain image",
  },
  //public domain
  {
    puzzlenumber: 16,
    lastname: "Stowe",
    quote:
      "So much has been said and sung of beautiful young girls, why doesn't somebody wake up to the beauty of old women?",
    link: "https://en.wikipedia.org/wiki/Harriet_Beecher_Stowe",
    bio: "Harriet Elisabeth Beecher Stowe was an American author and abolitionist. She came from the religious Beecher family and wrote the popular novel Uncle Tom's Cabin, which depicts the harsh conditions experienced by enslaved African Americans.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Beecher-Stowe.jpg/960px-Beecher-Stowe.jpg",
    attribution: "public domain image",
  },
  //public domain
  {
    puzzlenumber: 17,
    lastname: "Alcott",
    quote:
      "I believe that it is as much a right and duty for women to do something with their lives as for men and we are not going to be satisfied with such frivolous parts as you give us.",
    link: "https://en.wikipedia.org/wiki/Louisa_May_Alcott",
    bio: "Louisa May Alcott was an American novelist, short story writer, and poet best known for writing the novel Little Women. Alcott was an abolitionist and a feminist and remained unmarried throughout her life. She also spent her life active in reform movements such as temperance and women's suffrage.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Louisa_May_Alcott%2C_c._1870_-_Warren%27s_Portraits%2C_Boston.jpg/960px-Louisa_May_Alcott%2C_c._1870_-_Warren%27s_Portraits%2C_Boston.jpg",
    attribution: "public domain image",
  },
  //public domain
  {
    puzzlenumber: 18,
    lastname: "Sinclair",
    quote:
      "If you don't believe in yourself, you'll have some difficulty in making other people believe in you.",
    link: "https://en.wikipedia.org/wiki/May_Sinclair",
    bio: "May Sinclair was the pseudonym of Mary Amelia St. Clair, a popular British writer who wrote about two dozen novels, short stories and poetry. She was an active suffragist, and member of the Woman Writers' Suffrage League. She is attributed with first using the term 'stream of consciousness' in a literary context.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/May_Sinclair_001.jpg/960px-May_Sinclair_001.jpg",
    attribution: "public domain image",
  },
  //public domain
  {
    puzzlenumber: 19,
    lastname: "Yalow",
    quote:
      "We still live in a world in which a significant fraction of people, including women, believe that a woman belongs and wants to belong exclusively in the home.",
    link: "https://en.wikipedia.org/wiki/Rosalyn_Sussman_Yalow",
    bio: "Rosalyn Sussman Yalow was an American medical physicist, and a co-winner of the 1977 Nobel Prize in Physiology or Medicine for development of the radioimmunoassay technique.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Rosalyn_Yalow.jpg/1920px-Rosalyn_Yalow.jpg",
    attribution: "public domain image",
  },
  //pd
  {
    puzzlenumber: 20,
    lastname: "Addams",
    quote:
      "That person is most cultivated who is able to put himself in the place of the greatest number of other persons.",
    link: "https://en.wikipedia.org/wiki/Jane_Addams",
    bio: "Laura Jane Addams was an American settlement activist, reformer, social worker, sociologist, public administrator, philosopher, and author. She was a co-founder of the American Civil Liberties Union (ACLU).",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c4/Jane_Addams_-_Bain_News_Service.jpg/960px-Jane_Addams_-_Bain_News_Service.jpg",
    attribution: "public domain image",
  },
  //pd
  {
    puzzlenumber: 21,
    lastname: "Kahlo",
    quote: "I paint my own reality.",
    link: "https://en.wikipedia.org/wiki/Frida_Kahlo",
    bio: "Magdalena Carmen Frida Kahlo y Calderón was a Mexican painter known for her many portraits, self-portraits, and works inspired by the nature and artifacts of Mexico. Inspired by the country's popular culture, she employed a naïve folk art style to explore questions of identity, postcolonialism, gender, class, and race in Mexican society. She is also known for painting about her experience of chronic pain.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Frida_Kahlo%2C_by_Guillermo_Kahlo.jpg/960px-Frida_Kahlo%2C_by_Guillermo_Kahlo.jpg",
    attribution: "public domain image",
  },
  //pd
  {
    puzzlenumber: 22,
    lastname: "Nightingale",
    quote:
      "Were there none who were discontented with what they have, the world would never reach anything better.",
    link: "https://en.wikipedia.org/wiki/Florence_Nightingale",
    bio: "Florence Nightingale was an English social reformer, statistician and the founder of modern nursing. Nightingale came to prominence while serving as a manager and trainer of nurses during the Crimean War. She significantly reduced death rates by improving hygiene and living standards.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ab/Florence_Nightingale_%28H_Hering_NPG_x82368%29.jpg/960px-Florence_Nightingale_%28H_Hering_NPG_x82368%29.jpg",
    attribution: "public domain image",
  },
  //pd
  {
    puzzlenumber: 23,
    lastname: "Pankhurst",
    quote:
      "We are here, not because we are law-breakers; we are here in our efforts to become law-makers.",
    link: "https://en.wikipedia.org/wiki/Emmeline_Pankhurst",
    bio: "Emmeline Pankhurst was an English political activist who organised the British suffragette movement and helped women win the right to vote. She was widely criticised for her militant tactics, and historians disagree about their effectiveness, but her work is recognised as a crucial element in achieving women's suffrage in the United Kingdom.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/25/Emmeline_Pankhurst%2C_seated_%281913%29.jpg/960px-Emmeline_Pankhurst%2C_seated_%281913%29.jpg",
    attribution: "public domain image",
  },
  //pd
  {
    puzzlenumber: 24,
    lastname: "Bly",
    quote: "Energy rightly applied and directed will accomplish anything.",
    link: "https://en.wikipedia.org/wiki/Nellie_Bly",
    bio: "Elizabeth Cochrane Seaman, better known by her pen name Nellie Bly, was an American journalist, who was widely known for her record-breaking trip around the world in 72 days, and an exposé in which she worked undercover to report on a mental institution from within.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/5/52/Nellie_Bly_2.jpg",
    attribution: "public domain image",
  },
  //pd
  {
    puzzlenumber: 25,
    lastname: "Parks",
    quote:
      "It takes more than one person to bring about peace — it takes all of us.",
    link: "https://en.wikipedia.org/wiki/Rosa_Parks",
    bio: 'Rosa Louise McCauley Parks was an American activist in the civil rights movement best known for her pivotal role in the Montgomery bus boycott. The United States Congress has honored her as "the first lady of civil rights" and "the mother of the freedom movement".',
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Rosa_Parks%2C_November_1956_%28cropped%29.jpg/960px-Rosa_Parks%2C_November_1956_%28cropped%29.jpg",
    attribution: "public domain image",
  },
  //pd
  {
    puzzlenumber: 26,
    lastname: "Jex-Blake",
    quote:
      "It is a grand thing to enter the very first British University ever opened to women, isn't it?",
    link: "https://en.wikipedia.org/wiki/Sophia_Jex-Blake",
    bio: "Sophia Louisa Jex-Blake was an English physician, teacher, and feminist. She led the campaign to secure women access to a university education, when six other women and she, collectively known as the Edinburgh Seven, began studying medicine at the University of Edinburgh.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/1/1f/Sophia_Jex-Blake_Aged_25.jpg",
    attribution: "public domain image",
  },
  //pd
  {
    puzzlenumber: 27,
    lastname: "Meitner",
    quote: "Life need not be easy, provided only that it is not empty.",
    link: "https://en.wikipedia.org/wiki/Lise_Meitner",
    bio: "Lise Meitner was an Austrian-Swedish physicist who was one of those responsible for the discovery of the element protactinium and nuclear fission.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Lise_Meitner_NatGeo.jpg/960px-Lise_Meitner_NatGeo.jpg",
    attribution: "public domain image",
  },
  //pd
  {
    puzzlenumber: 28,
    lastname: "Walker",
    quote:
      "Don't sit down and wait for the opportunities to come; you have to get up and make them.",
    link: "https://en.wikipedia.org/wiki/Madam_C._J._Walker",
    bio: "Madam C. J. Walker was an American entrepreneur, philanthropist, and political and social activist. She is recorded as the first female self-made millionaire in America in the Guinness Book of World Records. Walker made her fortune by developing and marketing a line of cosmetics and hair care products for black women through the business she founded, Madam C. J. Walker Manufacturing Company.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dc/Madam_C._J._Walker_by_Addison_N._Scurlock.jpg/960px-Madam_C._J._Walker_by_Addison_N._Scurlock.jpg",
    attribution: "public domain image",
  },
  //pd
  {
    puzzlenumber: 29,
    lastname: "Hayes",
    quote:
      "From your parents you learn love and laughter and how to put one foot before the other. But when books are opened you discover that you have wings.",
    link: "https://en.wikipedia.org/wiki/Helen_Hayes",
    bio: "Helen Hayes MacArthur was an American actress whose career spanned 82 years. She eventually received the nickname 'First Lady of American Theatre' and was the second person and first woman to have won an Emmy, a Grammy, an Oscar, and a Tony Award (an EGOT).",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Helen_Hayes_1948.jpg/960px-Helen_Hayes_1948.jpg",
    attribution: "public domain image",
  },
  //pd
  {
    puzzlenumber: 30,
    lastname: "Albright",
    quote:
      "I do not believe things happen accidentally. I believe you earn them.",
    link: "https://en.wikipedia.org/wiki/Madeleine_Albright",
    bio: "Madeleine Jana Korbel Albright was an American diplomat and political scientist who served as the 64th United States secretary of state from 1997 to 2001. A member of the Democratic Party, Albright was the first woman to hold that post.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Secalbright.jpg/960px-Secalbright.jpg",
    attribution: "public domain image",
  },
  //cc
  {
    puzzlenumber: 31,
    lastname: "Christie",
    quote: "The science of tomorrow is the supernatural of today.",
    link: "https://en.wikipedia.org/wiki/Agatha_Christie",
    bio: 'Dame Agatha Mary Clarissa Christie was an English writer known for her 66 detective novels and 14 short story collections. Christie has been called the "Queen of Crime"—a moniker which is now trademarked by her estate—or the "Queen of Mystery".',
    image:
      "https://upload.wikimedia.org/wikipedia/commons/b/b4/Agatha_Christie_as_a_young_woman.jpg",
    attribution: "public domain image",
  },
  //cc
  {
    puzzlenumber: 32,
    lastname: "Roosevelt",
    quote:
      "We must know what we think and speak out, even at the risk of unpopularity.",
    link: "https://en.wikipedia.org/wiki/Eleanor_Roosevelt",
    bio: "Anna Eleanor Roosevelt was an American political figure, diplomat, and activist. Through her travels, public engagement, and advocacy, she largely redefined the role of First Lady. She advocated for expanded roles for women in the workplace, the civil rights of African Americans and Asian Americans, and the rights of World War II refugees.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7d/Eleanor_Roosevelt_at_the_United_Nations%2C_circa_1946-1947_%283x4_cropped%29.jpg/960px-Eleanor_Roosevelt_at_the_United_Nations%2C_circa_1946-1947_%283x4_cropped%29.jpg",
    attribution:
      "By FDR Presidential Library & Museum - https://www.flickr.com/photos/fdrlibrary/50517137801/, CC BY 2.0, https://commons.wikimedia.org/w/index.php?curid=172507023",
  },
  //pd
  {
    puzzlenumber: 33,
    lastname: "Hepburn",
    quote: "I believe in being strong when everything seems to be going wrong.",
    link: "https://en.wikipedia.org/wiki/Audrey_Hepburn",
    bio: "Audrey Kathleen Hepburn was a British actress. Recognised as a film and fashion icon, she was ranked by the American Film Institute as the third-greatest female screen legend from the Classical Hollywood cinema. Later in life, Hepburn devoted much of her time to UNICEF, to which she had contributed since 1954.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/74/AudreyKHepburn.jpg/960px-AudreyKHepburn.jpg",
    attribution: "public domain image",
  },
  //pd
  {
    puzzlenumber: 34,
    lastname: "Duncan",
    quote:
      "Will and energy sometimes prove greater than either genius or talent or temperament.",
    link: "https://en.wikipedia.org/wiki/Isadora_Duncan",
    bio: "Angela Isadora Duncan was an American-born dancer and choreographer, who was a pioneer of modern contemporary dance, who performed to great acclaim throughout Europe and the US. Duncan's philosophy of dance moved away from rigid ballet technique and towards what she perceived as natural movement.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/0/0a/Isadora_Duncan_portrait_cropped.jpg",
    attribution: "public domain image",
  },
  //cc
  {
    puzzlenumber: 35,
    lastname: "Kitt",
    quote:
      "It's all about falling in love with yourself and sharing that love with someone who appreciates you.",
    link: "https://en.wikipedia.org/wiki/Eartha_Kitt",
    bio: 'Eartha Mae Kitt was an American singer and actress known for her highly distinctive singing style and her 1953 recording of "Santa Baby". Kitt found a new generation of fans through her roles in the Disney films The Emperor\'s New Groove and Holes.',
    image:
      "https://upload.wikimedia.org/wikipedia/commons/9/98/Eartha_Kitt_visit_to_Israel_%28997009326916805171%29_%28cropped%29.jpg",
    attribution:
      "By Boris Carmi /Meitar Collection / National Library of Israel / The Pritzker Family National Photography Collection, CC BY 4.0, https://commons.wikimedia.org/w/index.php?curid=139793720",
  },
  //pd
  {
    puzzlenumber: 36,
    lastname: "Tallchief",
    quote:
      "I don't mind being listed alphabetically. I do mind being treated alphabetically.",
    link: "https://en.wikipedia.org/wiki/Maria_Tallchief",
    bio: "Elizabeth Marie Tallchief was an American ballerina. She was considered America's first major prima ballerina. She was the first Native American (Osage Nation) to hold the rank, and is said to have revolutionized ballet.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/c/c1/Maria_Tallchief_1961.png",
    attribution: "public domain image",
  },
  //pd
  {
    puzzlenumber: 37,
    lastname: "Shelley",
    quote:
      "Of what a strange nature is knowledge! It clings to the mind, when it has once seized on it, like a lichen on the rock.",
    link: "https://en.wikipedia.org/wiki/Mary_Shelley",
    bio: "Mary Wollstonecraft Shelley was an English novelist who is best known for writing the Gothic novel Frankenstein; or, The Modern Prometheus, which is considered an early example of science fiction. Shelley's works often argue that cooperation and sympathy, particularly as practised by women in the family, were the ways to reform civil society.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/Mary_Wollstonecraft_Shelley_Rothwell.tif/lossy-page1-960px-Mary_Wollstonecraft_Shelley_Rothwell.tif.jpg",
    attribution: "public domain image",
  },
  //pd
  {
    puzzlenumber: 38,
    lastname: "Holiday",
    quote:
      "If I'm going to sing like someone else, then I don't need to sing at all.",
    link: "https://en.wikipedia.org/wiki/Billie_Holiday",
    bio: "Billie Holiday was an American jazz and swing music singer. Her vocal style, strongly influenced by jazz instrumentalists, inspired a new way of manipulating phrasing and tempo.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bf/Portrait_of_Billie_Holiday_and_Mister%2C_Downbeat%2C_New_York%2C_N.Y.%2C_ca._Feb._1947_%28LOC%2C_5020400274%2C_cropped%29.jpg/960px-Portrait_of_Billie_Holiday_and_Mister%2C_Downbeat%2C_New_York%2C_N.Y.%2C_ca._Feb._1947_%28LOC%2C_5020400274%2C_cropped%29.jpg",
    attribution: "public domain image",
  },
  //pd
  {
    puzzlenumber: 39,
    lastname: "Lange",
    quote:
      "A portrait is a lesson on how one human being should approach another.",
    link: "https://en.wikipedia.org/wiki/Dorothea_Lange",
    bio: "Dorothea Lange was an American documentary photographer and photojournalist. Lange's photographs influenced the development of documentary photography and humanized the consequences of the Great Depression.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/c/cd/Dorothea_Lange_atop_automobile_in_California_%28restored%29_%28cropped%29.jpg",
    attribution: "public domain image",
  },
  //pd
  {
    puzzlenumber: 40,
    lastname: "Jorgensen",
    quote: "Gender refers to who you are as a human.",
    link: "https://en.wikipedia.org/wiki/Christine_Jorgensen",
    bio: "Christine Jorgensen was an American actress, singer, recording artist, and transgender activist. Jorgensen's highly publicized transition helped bring to light gender identity and shaped a new culture of more inclusive ideas about the subject.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/8/87/Christine_Jorgensen_1954.jpg",
    attribution: "public domain image",
  },
  //pd
  {
    puzzlenumber: 41,
    lastname: "Carson",
    quote: "In every grain of sand there is a story of the earth.",
    link: "https://en.wikipedia.org/wiki/Rachel_Carson",
    bio: "Rachel Louise Carson was an American marine biologist, writer, and conservationist whose sea trilogy and book Silent Spring are credited with advancing marine conservation and the global environmental movement.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f4/Rachel-Carson.jpg/960px-Rachel-Carson.jpg",
    attribution: "public domain image",
  },
  //cc
  {
    puzzlenumber: 42,
    lastname: "Makeba",
    quote: "I look at the past and I see myself.",
    link: "https://en.wikipedia.org/wiki/Miriam_Makeba",
    bio: "Zenzile Miriam Makeba, nicknamed Mama Africa, was a South African singer, songwriter, actress, and civil rights activist. She brought African music to a Western audience, and popularized the world music and Afropop genres.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/3/3d/Miriam_makeba_01.jpg",
    attribution:
      "By Paul Weinberg - Direct donation from the author, CC BY-SA 3.0, https://commons.wikimedia.org/w/index.php?curid=26754877",
  },
  //pd
  {
    puzzlenumber: 43,
    lastname: "Fitzgerald",
    quote: "It isn't where you came from, it's where you're going that counts.",
    link: "https://en.wikipedia.org/wiki/Ella_Fitzgerald",
    bio: 'Ella Jane Fitzgerald was an American jazz singer. She was noted for her purity of tone, impeccable diction, phrasing, timing, intonation, and a "horn-like" improvisational ability, particularly in her scat singing.',
    image:
      "https://upload.wikimedia.org/wikipedia/commons/6/65/Ella_Fitzgerald_1962.JPG",
    attribution: "public domain image",
  },
  //pd
  {
    puzzlenumber: 44,
    lastname: "Woolf",
    quote:
      "If you do not tell the truth about yourself you cannot tell it about other people.",
    link: "https://en.wikipedia.org/wiki/Virginia_Woolf",
    bio: "Adeline Virginia Woolf was an English writer. She is considered one of the most important modernist 20th-century authors. Her works, translated into more than 50 languages, have attracted attention and widespread commentary for inspiring feminism.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0b/George_Charles_Beresford_-_Virginia_Woolf_in_1902_-_Restoration.jpg/960px-George_Charles_Beresford_-_Virginia_Woolf_in_1902_-_Restoration.jpg",
    attribution: "public domain image",
  },
  //pd
  {
    puzzlenumber: 45,
    lastname: "Montagu",
    quote: "General notions are generally wrong.",
    link: "https://en.wikipedia.org/wiki/Lady_Mary_Wortley_Montagu",
    bio: "Lady Mary Wortley Montagu was an English aristocrat, medical pioneer, writer, and poet. Aside from her writing, Mary is also known for introducing and advocating smallpox inoculation in Britain after her return from Turkey.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/Jonathan_Richardson_d._J._001.jpg/960px-Jonathan_Richardson_d._J._001.jpg",
    attribution: "public domain image",
  },
  //pd
  {
    puzzlenumber: 46,
    lastname: "Truth",
    quote:
      "I will not allow my life's light to be determined by the darkness around me.",
    link: "https://en.wikipedia.org/wiki/Sojourner_Truth",
    bio: "Sojourner Truth was an American abolitionist and activist for African-American civil rights, women's rights, and alcohol temperance. Her best-known speech was delivered extemporaneously, at the Ohio Women's Rights Convention in Akron, Ohio. The speech became widely known during the Civil War by the title \"Ain't I a Woman?\"",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/54/Sojourner_Truth%2C_1870_%28cropped%2C_restored%29.jpg/960px-Sojourner_Truth%2C_1870_%28cropped%2C_restored%29.jpg",
    attribution: "public domain image",
  },
  //pd
  {
    puzzlenumber: 47,
    lastname: "Keller",
    quote: "Alone we can do so little. Together we can do so much.",
    link: "https://en.wikipedia.org/wiki/Helen_Keller",
    bio: "Helen Adams Keller was an American author, disability rights advocate, political activist and lecturer. Keller campaigned for those with disabilities, for women's suffrage, labor rights, and world peace.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Helen_Keller_%28circa_1904%29.jpg/960px-Helen_Keller_%28circa_1904%29.jpg",
    attribution: "public domain image",
  },
  //pd
  {
    puzzlenumber: 48,
    lastname: "Wong",
    quote: "I was so tired of the parts I had to play.",
    link: "https://en.wikipedia.org/wiki/Anna_May_Wong",
    bio: "Wong Liu Tsong, known professionally as Anna May Wong, was an American actress, considered the first Chinese American film star in Hollywood, as well as the first Chinese American actress to gain international recognition.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/8/83/Anna_May_Wong_-_portrait.jpg",
    attribution: "public domain image",
  },
  //cc
  {
    puzzlenumber: 49,
    lastname: "Handler",
    quote:
      "Through the doll, the little girl could be anything she wanted to be.",
    link: "https://en.wikipedia.org/wiki/Ruth_Handler",
    bio: "Ruth Marianna Handler was an American businesswoman and inventor. She is best known for inventing the Barbie doll, and being co-founder of toy manufacturer Mattel.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/50/Ruth_Handler_1961_%28cropped%29.jpg/960px-Ruth_Handler_1961_%28cropped%29.jpg",
    attribution:
      "By Originally published by the Los Angeles Times. Photographer unknown. Restored by Adam Cuerden - https://digital.library.ucla.edu/catalog/ark:/21198/zz0002qg0b, CC BY 4.0, https://commons.wikimedia.org/w/index.php?curid=134689736",
  },
  //pd
  {
    puzzlenumber: 50,
    lastname: "Mink",
    quote:
      "America is not a country which needs to demand conformity of its people, for its strength lies in all our diversities converging in one common belief.",
    link: "https://en.wikipedia.org/wiki/Patsy_Mink",
    bio: "Patsy Matsu Mink was an American attorney and politician from the U.S. state of Hawaii. She was the first woman of color and the first Asian-American woman elected to Congress, and is known for her work on legislation advancing women's rights and education.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/81/Patsy_Mink_1994_portrait_%28cropped%29.tif/lossy-page1-960px-Patsy_Mink_1994_portrait_%28cropped%29.tif.jpg",
    attribution: "public domain image",
  },
];
